export enum JournalChangeType {
  /**
   * 入金
   */
  RECHARGE = 0,
  /**
   * 出金
   */
  WITHDRAW = 1,
  /**
   * 冻结
   */
  FREEZE = 2,
  /**
   * 解冻
   */
  UNFREEZE = 3,
  /**
   * 扣款
   */
  WITHHOLD = 4,
  /**
   * 退款
   */
  REFUND = 5,
  /**
   * 冲正
   */
  VOIDING = 6,
  /**
   * 欠费
   */
  ARREARS = 7,
  /**
   * 补缴
   */
  REPAY = 8
}

export const JournalChangeTypeMap: Record<JournalChangeType, string> = {
  [JournalChangeType.RECHARGE]: '入金',
  [JournalChangeType.WITHDRAW]: '出金',
  [JournalChangeType.FREEZE]: '冻结',
  [JournalChangeType.UNFREEZE]: '解冻',
  [JournalChangeType.WITHHOLD]: '扣款',
  [JournalChangeType.REFUND]: '退款',
  [JournalChangeType.VOIDING]: '冲正',
  [JournalChangeType.ARREARS]: '欠费',
  [JournalChangeType.REPAY]: '补缴'
}

/**
 * 是否为收入型变动
 */
export const isIncome = (type: JournalChangeType) => {
  return (
    type === JournalChangeType.RECHARGE ||
    type === JournalChangeType.UNFREEZE ||
    type === JournalChangeType.REFUND ||
    type === JournalChangeType.REPAY
  )
}

/**
 * 是否为支出型变动
 */
export const isExpense = (type: JournalChangeType) => {
  return (
    type === JournalChangeType.WITHDRAW ||
    type === JournalChangeType.FREEZE ||
    type === JournalChangeType.WITHHOLD ||
    type === JournalChangeType.ARREARS
  )
}
